import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { HARDCOPY_PRICE } from '../../settings';
import { formatPrice } from '../../tools';
import { HardcopyQuantityPage } from '../quantity/quantity';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';

@Component({
    selector: 'page-hardcopy-intro',
    templateUrl: 'intro.html'
})

export class HardcopyIntroPage {

    constructor(
        public analytics: FirebaseAnalytics,
        public navCtrl: NavController
    ) {

    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('HardcopyIntro');
        this.analytics.logEvent('present_offer', {
            currency: 'EUR',
            item_category: 'hardcopy',
            item_id: 'hardcopy_2020',
            item_name: 'Ireland - A Directory 2020',
            value: HARDCOPY_PRICE,
        });
    }

    public getPrice() {
        return formatPrice(HARDCOPY_PRICE);
    }

    public goToPurchaseQuantity() {
        this.navCtrl.push(HardcopyQuantityPage, {});
    }

}



// WEBPACK FOOTER //
// ./src/pages/purchase-hardcopy/pages/intro/intro.ts